import userSettingsModule from '@/store/modules/user-settings-module';

export default function addLocaleParam(baseUrl: string): URL {
  const locale = userSettingsModule.state.selectedLanguage;
  const newUrl = new URL(baseUrl);
  newUrl.searchParams.append('locale', locale as string);
  return newUrl;
}
